import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import scrollToTop from '../../../../hoc/scrollToTop';
import AvailableBookingPages from '../common/AvailableBookingPageList';
import css from './index.module.scss';

interface ElementProps {
  publicId: string;
  settings: IPurchases.SettingCompletion;
}

type Props = ElementProps & InjectedIntlProps;

const Subscribed: React.SFC<Props> = (props: Props) => {
  const {
    intl,
    settings: { bookingPages },
    publicId,
  } = props;
  return (
    <div className={css.Subscribed}>
      <div className={css.Subscribed__MessageSection}>
        <p className={css.Subscribed__MessageTitle}>
          {intl.formatMessage({ id: `purchases.subscribed.title` })}
        </p>
        <p className={css.Subscribed__MessageParagraph}>
          {intl.formatMessage({
            id: `purchases.subscribed.message1`,
          })}
        </p>
      </div>
      {bookingPages.length !== 0 && (
        <AvailableBookingPages
          publicId={publicId}
          bookingPages={bookingPages}
        />
      )}
    </div>
  );
};

export default injectIntl(scrollToTop(Subscribed));
